import { object, string } from "yup";

import { MAX_LENGTH_1000_VALIDATION_MESSAGE } from "shared/constants";

export const validationSchema = object().shape({
  text: string().trim().max(1000, MAX_LENGTH_1000_VALIDATION_MESSAGE),
});
